import { PoolInvestor } from 'generated'
import { Chains } from 'modules/blockChain/chains'
import { weiToNum } from 'modules/blockChain/utils/parseWei'
import { ContractRevenueManager } from 'modules/contracts/contracts'
import { DEFAULT_DECIMALS } from '../constants/poolAssets'
import {
  POOL_PROJECTED_REPAYMENT,
  POOL_PROJECTED_UTZ,
} from '../constants/PoolRisk'
import { getPoolInvestorByAddress } from './getPoolInvestorContract'

type Args = {
  chainId: Chains
  poolInvestor: PoolInvestor
}

export const getPoolProjectedApy = async ({ poolInvestor, chainId }: Args) => {
  const { risk } = getPoolInvestorByAddress(chainId, poolInvestor.address)
  const revenueManager = ContractRevenueManager.connectRpc({ chainId })

  const [apr, { share: lendersShare }] = await Promise.all([
    poolInvestor.interestRateAnnual(),
    revenueManager.shares(0),
  ])

  const aprNum = weiToNum(apr, DEFAULT_DECIMALS)
  const lendersShareNum = Number(lendersShare) / 100

  return (
    aprNum *
    POOL_PROJECTED_UTZ[risk] *
    POOL_PROJECTED_REPAYMENT[risk] *
    lendersShareNum
  )
}
